export default "__VITE_ASSET__5b34ac3e__"